export class SoftSorting {

   
    // constructor(public elements: NodeListOf<Element>, public view: string) {
    constructor(elements) {
        
        // console.log(elements)
        this.params = {
            filterByFormula: '',
            post_id: null,
        }

        this.elements = elements;
        this.params = {}
        this.init();
        // this.params.append('view', this.view);
        
    }


    init() {

        let _this = this

        // console.log(this.elements)

        // this.elements.forEach( item => {
        //     console.log(item)
        // })

        // this.elements

        // const postId = (<HTMLInputElement>document.getElementById('bryter_post_id')).value;
        const postId = window.BRYTER.postId
        const homeUrl = window.BRYTER.homeUrl;
        let url;

        
        // url = window.location.href;
        // console.log(params)
        this.params['post_id'] = postId
        this.params['dt_id'] = parseInt($('.dt-wrap').attr('dt-id'))

        // console.log('this.params::', this.params)
        // alert(parseInt($('.dt-wrap').attr('dt-id')))

        $(document).on('click', 'th[data-sort]', e => {
            // alert(1)
            let th = $(e.currentTarget),
                sortType = th.data('type'),
                columnName = th.data('sort'),
                sortOrder = th.attr('data-order')

            $('th[data-sort]').attr('data-order', '')

            sortOrder = ! sortOrder ? 'asc' : 'asc' == sortOrder ? 'desc' : 'asc'

            th.attr('data-order', sortOrder)

            // alert( sortType )

            // console.log( sortType, columnName, sortOrder )

            _this.sort( sortType, columnName, sortOrder )

        })

        $(document).on('click', '.filters-sorting-reset button', e => {
            e.preventDefault()

            let dt_id = $('.dropdown-filter').first().attr('data-dt-id')
            // let params = window.filters.params
            for ( let i in window.filters.params ) {
                if ( i != 'post_id' ) {
                    delete window.filters.params[i]
                }
            }
            window.filters.params['dt_id'] = dt_id
            
            $(`.filters-container input`).prop('checked', 0)
            $(`.filters-container input`).removeAttr('checked')
            $('.filters-container .filters-count').remove()
            $('.filters-container[data-soft-filter-active]').removeAttr('data-soft-filter-active')
            $('th.DataTable__cell').attr('data-order', '')

            window.filters.render('?', window.filters.params);

            // _this.sort( sortType, columnName, sortOrder )
            // $('.filters-container .Card__actions button[type="reset"]').trigger('click')

            // return false

        })

    }

    sort( sortType, columnName, sortOrder ) {

        let filters_params = {}
        if ( window.filters ) {
            filters_params = window.filters.params
        }
        
        let params = {
            ...filters_params,
            ...this.params,
            sorting: {
                sortType,
                columnName,
                sortOrder
            }
            
        }


        // console.log('this.params2::', params)

        $.ajax({
            url: BRYTER.ajaxUrl,
            data: {
                action: 'tableSort',
                params: params,
                env: BRYTER.envId,
            },

            success: function( html ) {
                // console.log($('.DataTableWrapper-' + params['dt_id']))
                $('.DataTableWrapper-' + params['dt_id'] + ' tbody').html($(html).find('.DataTableWrapper tbody').html())
                let columns = []

                $('#data-table-' + params['dt_id'] + ' thead td').each(function(){
                    if ( $(this).attr('data-type') == 'progressbar') {
                        columns.push({
                            searchable: true,
                            targets: 0,
                            'width': '10%'
                        })
                    } else {

                        columns.push({
                            searchable: true,
                            targets: 0,
                            width: '220px', //(100 / $('#cases-table thead td').length).toFixed(2) + '%'
                        })
                    }
                })


                
            }
        })
    }


}